export default "__VITE_ASSET__e95c0ba5__"